var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewLess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32213") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Added-postpaid-account-view-all",
    transform: "translate(-210.000000, -755.000000)",
    fill: "#007AFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-less",
    transform: "translate(219.000000, 763.000000) rotate(-90.000000) translate(-219.000000, -763.000000) translate(211.000000, 755.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 32213,
    transform: "translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34673773,5.24930761 L1.16312446,9.35672833 C0.896996124,9.61814482 0.465514643,9.61814482 0.199515504,9.35672833 C-0.066505168,9.0955444 -0.066505168,8.67192918 0.199515504,8.41076638 L3.90136736,4.77632664 L0.19962317,1.14201374 C-0.0663975022,0.880724101 -0.0663975022,0.457151163 0.19962317,0.19596723 C0.465643842,-0.0653224101 0.89710379,-0.0653224101 1.16323213,0.19596723 L5.34684539,4.30345137 C5.47985573,4.43410677 5.54628553,4.60516385 5.54628553,4.7763055 C5.54628553,4.94753171 5.47972653,5.11871564 5.34673773,5.24930761 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewLess);
export default __webpack_public_path__ + "static/media/view-less.0c4c77e577d537df687940bb40cacd77.svg";
export { ForwardRef as ReactComponent };